module.exports = __webpack_public_path__ + "media/images/app/products/index/types/rings-mobile-a4f7a14cdd7f48c0995a453516290d3b.webp";